var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-app noticeheight"},[_c('app-sidebar'),_c('div',{staticClass:"c-wrapper wrapper-content",attrs:{"id":"body"}},[_c('app-header'),_c('div',{staticClass:"c-body"},[_c('router-view')],1),_c('app-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }